<div *ngIf="isLoading || isDeletingRequest" class="overlay">
  <div class="spinner"></div>
  <p class="text-load">&nbsp;&nbsp; Loading...</p>
</div>
 
<!-- ── Request Listing View ── -->
<ng-container *ngIf="!showCreateModal">
  <div [class.blur]="isLoading || isDeletingRequest">
 
    <div class="breadcrumb-bar">
      <div class="breadcrumb">
        <span class="breadcrumb-current">Request</span>
      </div>
    </div>
 
    <main class="page-content">
      <section class="content-card">
 
        <div class="header-bar">
          <h2 class="title">Request Listing</h2>
          <div class="header-actions">
            <span class="export-text" [class.disabled]="isExporting" (click)="!isExporting && exportVisible()">Export Visible
              <span class="tooltip-container" (click)="$event.stopPropagation()">
                <mat-icon class="icon-info">info_outline</mat-icon>
                <span class="tooltip-text">Exports all rows for the columns currently visible.</span>
              </span>
            </span>
            <button class="btn-outline" (click)="exportAll()" [disabled]="isExporting">
              Export All
              <span class="tooltip-container" (click)="$event.stopPropagation()">
                <mat-icon class="icon-info">info_outline</mat-icon>
                <span class="tooltip-text">Export all request records with all available system columns.</span>
              </span>
            </button>
            <button class="btn-create" (click)="openCreateModal()">+ Create New Request</button>
          </div>
        </div>
 
        <!-- Search bar + Column Selector -->
        <div class="search-bar">
          <input type="text" placeholder="Search Request" [(ngModel)]="searchText" (ngModelChange)="currentPage = 1" />
          <span class="search-icon"><mat-icon>search</mat-icon></span>
          <mat-icon class="filter-icon" (click)="toggleFilterPanel()">filter_alt</mat-icon>
 
          <!-- Column Selector dropdown -->
          <div class="filter-dropdown" *ngIf="isFilterOpen">
            <div class="filter-header">
              <span>Column Selector</span>
              <mat-icon (click)="toggleFilterPanel()">close</mat-icon>
            </div>
 
            <div class="filter-search">
              <span class="search-icon-column"><mat-icon class="search-column">search</mat-icon></span>
              <input type="text" placeholder="Search" [(ngModel)]="columnSearchText" />
            </div>
 
            <div class="filter-list-box">
              <label *ngFor="let col of filteredColumns()" class="filter-checkbox">
                <input type="checkbox" [(ngModel)]="col.visible" />
                <span class="checkbox-custom"></span>
                <span class="checkbox-label">{{ col.label }}</span>
              </label>
            </div>
 
            <!-- <div class="filter-footer">
              Total Columns: <b>{{ totalColumnCount() }}</b> &nbsp;&nbsp; Visible: <b>{{ visibleColumnCount() }}</b>
            </div> -->
          </div>
        </div>
 
        <!-- Grid -->
        <div class="table-container">
          <table class="custom-table">
            <thead>
              <tr>
                <th *ngIf="isColumnVisible('requestId')" (click)="sort('requestId')" [class.active]="sortColumn === 'requestId'">
                  <span class="th-content">
                    Request ID
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('requestId') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('requestId')" (click)="toggleColumnFilter('requestId', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'requestId' }"></ng-container>
                </th>
 
                <!-- Configurable columns -->
                <th *ngIf="isColumnVisible('requestType')" (click)="sort('requestType')" [class.active]="sortColumn === 'requestType'">
                  <span class="th-content">
                    Request Type
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('requestType') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('requestType')" (click)="toggleColumnFilter('requestType', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'requestType' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('status')" (click)="sort('status')" [class.active]="sortColumn === 'status'">
                  <span class="th-content">
                    Status
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('status') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('status')" (click)="toggleColumnFilter('status', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'status' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('requestedBy')" (click)="sort('requestedBy')" [class.active]="sortColumn === 'requestedBy'">
                  <span class="th-content">
                    Requested By
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('requestedBy') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('requestedBy')" (click)="toggleColumnFilter('requestedBy', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'requestedBy' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('requestedDate')" (click)="sort('requestedDate')" [class.active]="sortColumn === 'requestedDate'">
                  <span class="th-content">
                    Requested Date
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('requestedDate') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('requestedDate')" (click)="toggleColumnFilter('requestedDate', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'requestedDate' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('nameOfClient')" (click)="sort('nameOfClient')" [class.active]="sortColumn === 'nameOfClient'">
                  <span class="th-content">
                    Name of Client
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('nameOfClient') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('nameOfClient')" (click)="toggleColumnFilter('nameOfClient', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'nameOfClient' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('dntProjectName')" (click)="sort('dntProjectName')" [class.active]="sortColumn === 'dntProjectName'">
                  <span class="th-content">
                    D&amp;T Project Name
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('dntProjectName') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('dntProjectName')" (click)="toggleColumnFilter('dntProjectName', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'dntProjectName' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('contractNumber')" (click)="sort('contractNumber')" [class.active]="sortColumn === 'contractNumber'">
                  <span class="th-content">
                    Contract Number
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('contractNumber') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('contractNumber')" (click)="toggleColumnFilter('contractNumber', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'contractNumber' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('deliveryCountry')" (click)="sort('deliveryCountry')" [class.active]="sortColumn === 'deliveryCountry'">
                  <span class="th-content">
                    Delivery Country
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('deliveryCountry') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('deliveryCountry')" (click)="toggleColumnFilter('deliveryCountry', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'deliveryCountry' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('city')" (click)="sort('city')" [class.active]="sortColumn === 'city'">
                  <span class="th-content">
                    City
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('city') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('city')" (click)="toggleColumnFilter('city', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'city' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('isRepletterProject')" (click)="sort('isRepletterProject')" [class.active]="sortColumn === 'isRepletterProject'">
                  <span class="th-content">
                    Would you be creating same project in Repletter tool?
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('isRepletterProject') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('isRepletterProject')" (click)="toggleColumnFilter('isRepletterProject', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'isRepletterProject' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('comments')" (click)="sort('comments')" [class.active]="sortColumn === 'comments'">
                  <span class="th-content">
                    Comments/Summery/Notes/Issue
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('comments') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('comments')" (click)="toggleColumnFilter('comments', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'comments' }"></ng-container>
                </th>
 
                <th *ngIf="isColumnVisible('assignedTo')" (click)="sort('assignedTo')" [class.active]="sortColumn === 'assignedTo'">
                  <span class="th-content">
                    Assigned to
                    <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('assignedTo') }}</span>
                    <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('assignedTo')" (click)="toggleColumnFilter('assignedTo', $event)">filter_alt</mat-icon>
                  </span>
                  <ng-container *ngTemplateOutlet="colFilter; context: { col: 'assignedTo' }"></ng-container>
                </th>
 
                <th class="action-col">Action</th>
              </tr>
            </thead>
 
            <!-- Column filter popup template -->
            <ng-template #colFilter let-col="col">
              <div class="col-filter-popup" *ngIf="activeFilterColumn === col" (click)="$event.stopPropagation()">
                <select [(ngModel)]="filters[col].op1">
                  <option *ngFor="let op of operators" [value]="op">{{ op }}</option>
                </select>
                <input type="text" [(ngModel)]="filters[col].val1" placeholder="Filter..." />
                <div class="popup-actions">
                  <button type="button" class="btn-reset" (click)="resetFilter(col)">Reset</button>
                  <button type="button" class="btn-apply" (click)="applyFilter()">Apply</button>
                </div>
              </div>
            </ng-template>
 
            <tbody>
              <tr *ngIf="filteredData().length === 0">
                <td [attr.colspan]="visibleColumnCount() + 1" class="no-data-message">No Data Found</td>
              </tr>
 
              <tr *ngFor="let item of filteredData() | slice:(currentPage-1)*pageSize:currentPage*pageSize">
                <td *ngIf="isColumnVisible('requestId')" class="request-id-cell">{{ item.requestId }}</td>
                <td *ngIf="isColumnVisible('requestType')">{{ item.requestType }}</td>
                <td *ngIf="isColumnVisible('status')">{{ item.status }}</td>
                <td *ngIf="isColumnVisible('requestedBy')">{{ item.requestedBy }}</td>
                <td *ngIf="isColumnVisible('requestedDate')">{{ item.requestedDate }}</td>
                <td *ngIf="isColumnVisible('nameOfClient')">{{ item.nameOfClient }}</td>
                <td *ngIf="isColumnVisible('dntProjectName')">{{ item.dntProjectName }}</td>
                <td *ngIf="isColumnVisible('contractNumber')">{{ item.contractNumber }}</td>
                <td *ngIf="isColumnVisible('deliveryCountry')">{{ item.deliveryCountry }}</td>
                <td *ngIf="isColumnVisible('city')">{{ item.city }}</td>
                <td *ngIf="isColumnVisible('isRepletterProject')">{{ item.isRepletterProject }}</td>
                <td *ngIf="isColumnVisible('comments')" class="truncate-cell" [attr.data-tip]="item.comments"><span class="truncate-text">{{ item.comments }}</span></td>
                <td *ngIf="isColumnVisible('assignedTo')">{{ item.assignedTo }}</td>
                <td class="actions action-col">
                  <span class="material-symbols-outlined view-icon" title="View" (click)="openRequest(item, 'view')">visibility</span>
                  <span class="material-symbols-outlined edit-icon" [class.icon-disabled]="isEditDisabled(item)" [title]="isEditDisabled(item) ? '' : 'Edit'" (click)="!isEditDisabled(item) && openRequest(item, 'edit')">edit_square</span>
                  <span class="material-symbols-outlined delete-icon" [class.icon-disabled]="isDeleteDisabled" [title]="isDeleteDisabled ? '' : 'Delete'" (click)="!isDeleteDisabled && openDeleteModal(item)">delete</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
 
        <!-- Pagination -->
        <div class="pagination">
          <span>Show</span>
          <select [(ngModel)]="pageSize" (change)="currentPage = 1">
            <option *ngFor="let size of [10, 25, 50]" [value]="size">{{ size }}</option>
          </select>
          <span>Items/page</span>
 
          <span>Go to page</span>
          <input type="number" [(ngModel)]="goToPageInput" (keyup.enter)="goToPage()" (change)="goToPage()" min="1" [max]="totalPages()" class="goto-input" />
 
          <button class="arrow" (click)="firstPage()" [disabled]="currentPage === 1">&#171;</button>
          <button class="arrow" (click)="prevPage()" [disabled]="currentPage === 1">&#8249;</button>
 
          <button *ngFor="let page of totalPagesArray()" [class.active]="page === currentPage" (click)="currentPage = page">
            {{ page }}
          </button>
 
          <button class="arrow" (click)="nextPage()" [disabled]="currentPage === totalPages()">&#8250;</button>
          <button class="arrow" (click)="lastPage()" [disabled]="currentPage === totalPages()">&#187;</button>
        </div>
 
      </section>
    </main>
  </div>
</ng-container>
 
<!-- ── Create Request View ── -->
<app-create-new-request
  *ngIf="showCreateModal"
  [existingSlNames]="existingSlNames"
  (close)="closeCreateModal()"
  (submitted)="onRequestSubmitted($event)">
</app-create-new-request>
 
<!-- ── Delete Confirmation Modal ── -->
<div class="delete-modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
  <div class="delete-modal" (click)="$event.stopPropagation()">
    <h2 class="delete-modal-title">Delete Request</h2>
    <p class="delete-modal-body">
      Are you sure you want to delete this request?
    </p>
    <div class="delete-modal-actions">
      <button type="button" class="delete-modal-cancel" (click)="closeDeleteModal()">Cancel</button>
      <button type="button" class="delete-modal-confirm" [disabled]="isDeletingRequest" (click)="confirmDelete()">
        Confirm Delete
      </button>
    </div>
  </div>
</div>
 
<!-- ── Success Toast ── -->
<div class="toast-success" [class.toast-visible]="showToast">
  <mat-icon class="toast-icon">check_circle</mat-icon>
  <div class="toast-body">
    <span class="toast-title">Success</span>
    <span class="toast-message">{{ toastMessage }}</span>
  </div>
  <mat-icon class="toast-close" (click)="dismissToast()">close</mat-icon>
</div>